import { useIsPlusQuery } from "@/hooks/queries";
import { isNativeApp } from "@/lib/native";

/** 광고를 노출해야 하는지 여부 (네이티브 앱 + 비구독자만 true) */
export function useShowAds() {
  const { data: isPlus = false } = useIsPlusQuery();

  return isNativeApp && !isPlus;
}
